class OldSessionStorageHelper {
  getCurrencyList() {
    const item = sessionStorage.getItem(`rin-currency-list`);
    if(item) {
      return JSON.parse(item);
    }
    return null;
  }

  setCurrencyList(value) {
    sessionStorage.setItem(`rin-currency-list`, JSON.stringify(value));
  }

  deleteRedirect() {
    sessionStorage.removeItem(`rin-redirect`);
  }

  getRedirect() {
    const item = sessionStorage.getItem(`rin-redirect`);
    if(item) {
      return item;
    }
    return null;
  }
}

export default new OldSessionStorageHelper();
